import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from 'src/app/providers/environment';
import { EmailSubscription } from 'src/app/types/subscription';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _emailSubscriptionData: EmailSubscription | undefined;

  private readonly env = inject(ENVIRONMENT);
  private readonly http = inject(HttpClient);

  get emailSubscriptionData() {
    if (!this._emailSubscriptionData) return undefined;

    return { ...this._emailSubscriptionData };
  }

  getEmailSubscriptionData(userId: string) {
    return this.http
      .get<EmailSubscription>(this.env.server + '/auth/email-subscription', {
        params: { userId },
      })
      .pipe(tap((data) => (this._emailSubscriptionData = data)));
  }

  unsubscribeFromMailingList(userId: string) {
    return this.http.delete(this.env.server + '/auth/email-subscription', {
      params: {
        userId,
      },
    });
  }

  subscribeToMailingList(userId: string) {
    return this.http.post(
      this.env.server + '/auth/email-subscription',
      {},
      {
        params: {
          userId,
        },
      },
    );
  }
}
